import { Spinner as CUISpinner } from '@chakra-ui/react';
import { Center }                from '@chakra-ui/react';
import { ConditionalValue }      from '@chakra-ui/react';

interface ISpinnerProps {
	size?: ConditionalValue<"sm" | "md" | "lg" | "xl" | "xs" | "inherit" | undefined>
}

const Spinner = (props: ISpinnerProps) => {
	const { size } = props;
	return (
		<Center height="100%" >
			<CUISpinner borderWidth="4px" size={size ? size : "xl"} />
		</Center>
	);
};

export default Spinner